// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__izQnC","buttons":"styles_buttons__2lQMH"};